import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick"];
import * as React from 'react';
import { unstable_useId as useId, useForkRef } from '@mui/material/utils';
import MenuList from '@mui/material/MenuList';


import { isHideMenuKey, isTabKey } from "@mui/x-data-grid/utils/keyboardUtils";
import { useGridApiContext } from "@mui/x-data-grid";
import { GridMenu } from "@mui/x-data-grid-pro";
import { useGridRootProps } from "@mui/x-data-grid-pro";
import { gridClasses } from "@mui/x-data-grid-pro";
import useMediaQuery from '@mui/material/useMediaQuery';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { getSession } from "../../../../../auth";
import useNotification from "../../../../Notification";
import UserPermissions from "../../../../User/Permissions";

export const GridToolbarImportClients = /*#__PURE__*/React.forwardRef(function GridToolbarImportClients(props, ref) {
  var _rootProps$components;

  const {
    children,
    onClick
  } = props,
        other = _objectWithoutPropertiesLoose(props, _excluded);

  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const buttonId = useId();
  const menuId = useId();
  const [open, setOpen] = React.useState(false);
  const buttonRef = React.useRef(null);
  const handleRef = useForkRef(ref, buttonRef);

  const handleMenuOpen = event => {
    setOpen(true);
    onClick == null ? void 0 : onClick(event);
  };

  const decideAdd = (event) => {
    const user = getSession()
    const issupervisor = UserPermissions().isSupervisor
    const cancreate = user.profile.create_contacts
  
    if (!issupervisor && !cancreate){
      useNotification(
        'Ops!',
        `Você não pode criar contatos.`,
        'warning'
      )
      return
    }
  
    handleMenuOpen(event)
  }

  const handleMenuClose = () => setOpen(false);

  const handleListKeyDown = event => {
    if (isTabKey(event.key)) {
      event.preventDefault();
    }

    if (isHideMenuKey(event.key)) {
      handleMenuClose();
    }
  };

  if (children == null) {
    return null;
  }
  const isSmallScreen = useMediaQuery('(max-width: 60rem)');

  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(rootProps.components.BaseButton, _extends({
      ref: handleRef,
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/_jsx(rootProps.components.ExportIcon, {}),
      "aria-expanded": open ? 'true' : undefined,
      "aria-label": isSmallScreen? '' : 'Adicionar',
      "aria-haspopup": "menu",
      "aria-labelledby": menuId,
      id: buttonId
    }, other, {
      onClick: decideAdd
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseButton, {
      children: isSmallScreen? '' : 'Adicionar'
    })), /*#__PURE__*/_jsx(GridMenu, {
      open: true,
      target: buttonRef.current,
      onClickAway: handleMenuClose,
      position: "bottom-start",
      children: /*#__PURE__*/_jsx(MenuList, {
        id: menuId,
        className: gridClasses.menuList,
        sx: {display: open ? 'block':'none'},
        "aria-labelledby": buttonId,
        onKeyDown: null,
        autoFocusItem: open,
        children: React.Children.map(children, child => {
          if (! /*#__PURE__*/React.isValidElement(child)) {
            return child;
          }
          return /*#__PURE__*/React.cloneElement(child, {
            hideMenu: handleMenuClose
          });
        })
      })
    })]
  });
});